interface TimetableViewProps {

}

const TimetableView: React.FunctionComponent<TimetableViewProps> = () => {
    return (
        <>
        </>
    );
}

export default TimetableView;